import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=dcf051e4&scoped=true&"
import script from "./develop.vue?vue&type=script&lang=js&"
export * from "./develop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf051e4",
  null
  
)

export default component.exports